module.exports = __webpack_public_path__ + "static/media/tomatouthappam.6a690c2f.jpg";